<div class="crypto-card" [class.intoBundle]="intoBundle" [class.group]="!show">
  <div class="coin-info-section">
    <img class="coin-logo" [src]="'/assets/icons/crypto/' + symbol + '.svg'" />
    <div class="coin-name-section">
      <span class="coin-name">{{ balance.ticker.toUpperCase() }}</span>
      <span class="coin-ticker" *ngIf="show">{{ balance?.name }}</span>
    </div>
  </div>
  <div class="coin-price-section">
    <span class="price" *ngIf="getPrices(balance.ticker) !== -1 && show">
      {{ equivalentInArs ? 'AR$' : 'U$D' }}
      {{ getPrices(balance.ticker) | formatCoinAmount : (equivalentInArs ? 'ARS' : 'USD') }}
    </span>
    <span class="price" *ngIf="getPrices(balance.ticker) === -1">-</span>
  </div>
  <div
    class="price-chart-container disappear-mobile disappear-medium-desktop"
    #priceChart
    *ngIf="show"
  >
    <div class="price-chart">
      <ngx-charts-line-chart
        *ngIf="history && history[0]?.series.length > 1"
        [view]="[240, 64]"
        [scheme]="colorScheme"
        [showXAxisLabel]="false"
        [showYAxisLabel]="false"
        [xAxis]="false"
        [yAxis]="false"
        [animations]="true"
        [timeline]="false"
        [results]="history"
        [showGridLines]="false"
        [curve]="curve"
        [yScaleMax]="minMax?.max"
        [yScaleMin]="minMax?.min"
        [tooltipDisabled]="true"
        style="background: #f3eef7"
      >
      </ngx-charts-line-chart>
    </div>
  </div>

  <div class="coin-variance-section" *ngIf="show">
    <span
      class="variance"
      [class.grow]="variation > 0"
      [class.drop]="variation < 0"
      *ngIf="variation < 0 || variation === 0 || variation > 0"
    >
      {{ variation > 0 ? '+' : '' }}{{ variation | number : '0.2-2' }}%
    </span>
  </div>

  <div class="coin-balance-section">
    <div class="coin-balance-value">
      <span class="equivalent-ars" *ngIf="+balance.balance !== 0 && show"
        >≈
        {{ equivalentInArs ? 'AR$' : 'U$D' }}
        {{
          equivalentInArs
            ? (balance.balanceArs | formatCoinAmount : 'ARS')
            : (balance.balance | formatCoinAmount : 'USD')
        }}</span
      >
      <span class="balance">
        <span>
          {{ balance.stocks | formatCoinAmount : balance.ticker }}
          {{ !show ? '' : balance.ticker }}
        </span>
        <!-- Caso excepcional AUST que viene sin price -->
      </span>
    </div>
  </div>
</div>
